import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector, useStore } from 'react-redux';

import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { ChildrenPropType } from '../../../../prop-types/children';
import Global from '../../../../store/global-selectors';
import { getPreviousAndNextOrdersGridIds } from '../../../../store/orders/orders.helpers';
import { setSelectedOrders } from '../../../../store/orders/selected-orders/orders.selected-orders.actions';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { defaultOrderDetailsNavigationContext, OrderDetailsNavigationContext } from './order-details-navigation-context';

const OrdersPageNavigationContextProvider = ({ children }) => {
  const [value, setValue] = useState(defaultOrderDetailsNavigationContext);
  const isGridLoading = useSelector(Global.selectOrdersGridIsLoading);
  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  const dispatch = useDispatch();
  const { getState } = useStore();

  useEffect(() => {
    if (isGridLoading) {
      return;
    }

    const state = getState();
    const fulfillmentPlanIdsInGrid = Global.selectOrdersGridOrders(state);
    const fulfillmentPlansInGrid = Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds: fulfillmentPlanIdsInGrid });

    setValue(getPreviousAndNextOrdersGridIds(fulfillmentPlansInGrid, fulfillmentPlanId, salesOrderId));
    if (fulfillmentPlanIdsInGrid?.includes(fulfillmentPlanId)) {
      dispatch(setSelectedOrders([fulfillmentPlanId]));
    }
  }, [dispatch, fulfillmentPlanId, getState, isGridLoading, salesOrderId]);

  return <OrderDetailsNavigationContext.Provider value={value}>{children}</OrderDetailsNavigationContext.Provider>;
};

export default OrdersPageNavigationContextProvider;

OrdersPageNavigationContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
